import client from '../http_client';
import { NotificationsResponse } from './types';

const root = '/v1/notifications';

export class NotificationsService {
  public static async getNotifications(): Promise<NotificationsResponse> {
    const response = await client.get<NotificationsResponse>(root);
    // Normalize IDs to strings immediately to ensure consistency for localStorage keys
    const data = response.data;
    return {
      count: data.count,
      notifications: data.notifications.map((n: any) => ({
        ...n,
        id: String(n.id),
      })),
    };
  }
}
